<template lang="pug">
.infowrapper
    h1.info(ref="infos") {{inforef}}
</template>

<script lang="ts">
// Info(:w="res.x" :h="res.y" v-if="debug")
export default ({
    props:{
        w:{type: Number,default: 0,required: true},
        h:{type: Number,default: 0,required: true}
    },
    data(){
        return{
            inforef: ''
        }
    },
    mounted(){
        window.onmousemove=(e)=>{
            // console.log(e.x,e.y,e.clientY,e.offsetY,e.pageY,e.screenY)
            const tmp=(this.$refs.infos)
            const style=window.getComputedStyle(tmp)
            const tw=Number(style.getPropertyValue('width').slice(0,-2))
            const th=Number(style.getPropertyValue('height').slice(0,-2))
            const upblack=(window.innerHeight-th)/2
            // console.log(e.y,th,window.innerHeight,this.h,upblack)
            this.inforef=Math.floor(e.x/tw*this.w)+','+Math.floor((e.y-upblack)/th*this.h)
        }
        console.log('mounted',this.inforef)
    }
})
</script>

<style lang="sass" scoped>
@import '@/styles/common'
.info
    +full()
    pointer-events: none
    // background: #f006
    color: white
    text-align: right
    -webkit-text-stroke: 1px gray
</style>